import { getAdmins, saveAdmin, removeAdmin } from '../../services/settingsServices';
import _ from "lodash";

const state = {
    admins: {},
}

const getters = {
    getAdmins(state) {
        return state.admins;
    },
}

const actions = {
    getAdmins({ commit }, input) {
        return new Promise((resolve, reject) => {
            getAdmins(input).then(response => {
                if (response.status == 200) {
                    let result = _.clone(response.data.data);
                    // let  appresponse = result.map(el => ({ ...el, status:el.isActive?'Active':'InActive'}))  
                    // appresponse.totalRecords = response.data.data.totalRecords;
                    // appresponse.pageNo = response.data.data.pageNo;              
                    commit('setAdmins', result);
                    resolve();
                }
            })
                .catch(error => {
                    reject(error);
                });
        });
    },
    saveAdmin({ commit }, input) {
        return new Promise((resolve, reject) => {
            saveAdmin(input).then(response => {
                if (response.status == 200) {
                    let result = _.clone(response.data.data);
                    commit('setAdmins', result);
                    resolve();
                }
            })
                .catch(error => {
                    reject(error);
                });
        });
    },
    removeAdmin({ commit }, input) {
        return new Promise((resolve, reject) => {
            removeAdmin(input).then(response => {
                if (response.status == 200) {
                    let result = _.clone(response.data.data);
                    commit('setAdmins', result);
                    resolve();
                }
            })
                .catch(error => {
                    reject(error);
                });
        });
    },
}

const mutations = {
    setAdmins(state, response) {
        state.admins = response;
    }
}

export default {
    namespaced: true,
    actions,
    getters,
    mutations,
    state,
}